import React, { Component } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './NavbarCSS.css'
import {auth} from './Firebase'
import {onAuthStateChanged} from "firebase/auth";

 

export default class Navbar extends Component {
  constructor(props){
    super(props);
    this.state ={
      tab: window.sessionStorage.getItem('tab'),
      Nav:false
    }
  }
  
//function for navbar contain
  onChangeTab =(index) => {
    window.sessionStorage.setItem('tab', JSON.stringify(index))
    let data = window.sessionStorage.getItem('tab')
    this.setState({
      tab : data
    })
  }


//function for responsive navbar designing (mobile view)
  onChangeNav =()=>{
    this.setState({
      Nav:!this.state.Nav
    })
  }
  
  
  handleLogIn=(e)=>{
    e.preventDefault()
    this.onChangeTab(4)
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        console.log(uid);
        this.props.navigate('/Dashboard')
      } else {
        this.props.navigate('/Login')
      }
    });
  }
  
  render() {
    const {tab} = this.state;
    const {Nav} =this.state;
    console.log(tab)
    return (
      <React.Fragment> 
        {window.innerWidth > 768 ?
       <div className='Navbar'>
        <Link to='/'><img onClick={() => this.onChangeTab(0)}  className='Logo' src='https://www.washmartindia.in/static/media/logo.e24ced93.svg' alt='logo' width='130px' height='60px'></img></Link>
        <div>
        <ul className={(tab === null || tab=== '0' || tab=== '2')? 'NavbarText' : 'NavbarText1'}>
            <li onClick={()=>this.onChangeTab(1)}><Link  className={tab === '1' ? "active" : ""} to='/Pricing'>Pricing</Link></li>
            {(tab === null || tab=== '0' || tab=== '2' )?<li  onClick={()=>this.onChangeTab(2)}><a href='#Request' >Request A Call Back</a></li> 
            : ""}
            <li className="call"><a href='tel:9421114232'><img src='https://www.washmartindia.in/static/media/call.a6f6283b.svg' alt='call' width='20px' height='20px'></img> 9421114232</a></li>
            <li className={tab === '4' ? "active1" : "LB"}  onClick={(e)=>this.handleLogIn(e)}><button type='submit'>Login</button></li>
        </ul>
        </div>
        </div> : <div>
        
        <div className='Navbar1'>
        <Link to='/'><img onClick={() => this.onChangeTab(0)}  className='Logo' src='https://www.washmartindia.in/static/media/logo.e24ced93.svg' alt='logo' width='130px' height='60px'></img></Link>
        <img onClick={()=>this.onChangeNav()} className='NavButton' src='https://www.washmartindia.in/static/media/menu.4dec65d1.svg' alt='buttonNav' width='30px' height='30px'></img>
        </div>
        { Nav? <div className='NavbarText2'>
        <ul>
            <li onClick={()=>{this.onChangeTab(1);this.onChangeNav()}}><Link to='/Pricing'>Pricing</Link></li>
            {(tab === null || tab=== '0' || tab=== '2' )?<li  onClick={()=>{this.onChangeTab(2);this.onChangeNav()}}><a href='#Request' >Request A Call Back</a></li> 
            : ""}
            <li onClick={()=>{this.onChangeTab1(3);this.onChangeNav()}}><a href='tel:9421114232'><img src='https://www.washmartindia.in/static/media/call_white.45386434.svg' alt='call' width='20px' height='20px'></img> 9421114232</a></li>
            <li onClick={()=>{this.onChangeTab(4);this.onChangeNav()}}><button type='submit' onClick={()=>this.handleLogIn()}>Login</button></li>
        </ul>
        </div> :
        <div></div>}
        </div>}
      </React.Fragment>
    )
  }
}


export function NavbarH (props){
  const navigate = useNavigate()
  return(<Navbar navigate={navigate}/>)
}